import React from "react";
import { BootStrapDataProvider } from "./BootStrapDataContext";
import { ConciergeFilterProvider } from "./concierge/conciergeFilterContext";
import { FeatureFlagProvider } from "./featureFlags/FeatureFlagProvider";

interface AppProviderProps {
  children: React.ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  return (
    <BootStrapDataProvider>
      <ConciergeFilterProvider>
        <FeatureFlagProvider>
          {children}
        </FeatureFlagProvider>
      </ConciergeFilterProvider>
    </BootStrapDataProvider >
  );
};
